import React, { Component, useEffect, useState } from 'react';
import {
  Upload, message, Button
} from 'antd';
import {
  UploadOutlined, InboxOutlined
} from '@ant-design/icons';
import moment from 'moment';
import _ from 'lodash';
import debugLib from 'debug';
import { useTranslation } from 'react-i18next';

const { Dragger } = Upload;

function FormUploadFile(props) {
  const {t} = useTranslation();

  const {
    type,
    imageURL,
    data,
    onChange,
    onPreview,
    onRemove,
    fileList,
    action = "/api/media",
    acceptMimeTypes = ['image/png', 'image/jpeg'],
    beforeUpload,
  } = props;

  let DisplayContent;


  const uploadProps = {
    name: 'file',
    // multiple: true,
    action,
    beforeUpload: beforeUpload || ((file) => {
      if (!_.includes(acceptMimeTypes, file.type)) {
        message.error(t('common.accepted_format'));
        return false;
      }
      message.success(t('common.uploading'));
      return true;
    }),
    onError(err) {
      console.error(err)
      message.error(t('common.upload_fail'));
    }
  };

  if (type === 'one') {
    DisplayContent = <UploadOne uploadProps={uploadProps} fileList={fileList} imageURL={imageURL} data={data} onChange={onChange} onPreview={onPreview} onRemove={onRemove} />;
  } else if (type === 'button') {
    DisplayContent = <UploadButton uploadProps={uploadProps} fileList={fileList} imageURL={imageURL} data={data} onChange={onChange} onPreview={onPreview} onRemove={onRemove} />;
  } else {
    DisplayContent = <UploadWidget uploadProps={uploadProps} imageURL={imageURL} data={data} onChange={onChange} onPreview={onPreview} onRemove={onRemove} />;
  }

  return DisplayContent;
}

function UploadButton(props) {
  const {
    imageURL,
    data,
    onChange,
    onPreview,
    onRemove,
    uploadProps
  } = props;

  const [image, setImage] = useState('');

  useEffect(() => {
    setImage(imageURL)
  }, [imageURL])
  return (
    <>
      <Upload
        {...uploadProps}
        data={data}
        showUploadList={false}
        onChange={onChange}
        listType="text"
      // onPreview={onPreview}
      // onRemove={onRemove}
      >
        <Button
          shape="square"
          size="large"
          style={{
            backgroundColor: '#FFFFFF00',
            color: '#2B2B2B',
            marginLeft: 30,
            borderColor: '#2B2B2B',
            padding: '0px 20px',
            height: 40,
            width: 'auto',
            marginTop: 10,
            marginBottom: 20
          }}
          className="btn-hover"
        >
          上載
        </Button>
        {image && (
          <div>
            <img src={image} style={{ maxWidth: '100%' }} alt="" />
          </div>
        )}
      </Upload>
    </>
  );
}

function UploadOne(props) {
  const {
    imageURL,
    data,
    onChange,
    onPreview,
    onRemove,
    fileList,
    uploadProps
  } = props;

  const [image, setImage] = useState('');
  const [list, setfileList] = useState([]);

  useEffect(() => {
    setImage(imageURL)
  }, [imageURL])
  return (
    <Dragger
      {...uploadProps}
      data={data}
      showUploadList={false}
      onChange={onChange}
      listType="text"
      onPreview={onPreview}
      onRemove={onRemove}
    >
      {
        image
          ? (
            <div>
              <img src={image} style={{ maxWidth: '100%' }} alt="" />
            </div>
          ) : (
            <div>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">{'upload_msg1'}</p>
              <p className="ant-upload-hint">
                {'upload_msg2'}
              </p>
            </div>
          )
      }
    </Dragger>
  );
}

function UploadWidget(props) {
  const {
    imageURL,
    data,
    onChange,
    onPreview,
    onRemove,
    uploadProps
  } = props;

  const {t} = useTranslation();

  useEffect(() => { }, [imageURL])
  return (
    <Dragger
      {...uploadProps}
      showUploadList={false}
      data={data}
      onChange={onChange}
      listType="picture"
      onPreview={onPreview}
      onRemove={onRemove}
    >
      {
        imageURL
          ? (
            <div>
              <img src={imageURL} style={{ maxWidth: '100%' }} alt="" />
            </div>
          ) : (
            <div>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">{t('common.click_and_drag')}</p>
              <p className="ant-upload-hint">
                {t('common.accepted_format')}
              </p>
            </div>
          )
      }
    </Dragger>
  );
}

export default FormUploadFile;
